import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {} from "react-bootstrap";
import style from "../../codeactivation/codeactive.module.scss";
import { CurrencyDecimalFormat } from "../../../helper";
import { FaInfoCircle } from "react-icons/fa";
function Tiles(props) {
  console.log("tiles data", props);
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const Currency = useSelector((state) => state.curr);
  useEffect(() => {
    let ewalletTiles = props.tilesData.map((items) => {
      var background;
      var img;
      var text;
      var color;
      var tool;
      switch (items.text) {
        case "totalAvailableIncome":
          background = "#38CC77";
          text = "Total Available Income";
          img = "available_income.png";
          color = "#2827CC";
          tool = "Your Current Total Encashable Income ";
          text = "totalAvailableIncome";
          break;
        case "totalSuspended":
          background = "#FF6263";
          text = "Total Suspended This Month";
          img = "danger.png";
          color = "#ffd9d9";
          tool =
            "You don't have Pv maintance this month.Please Process It Inorder to earn the suspended income or else it will be forfeited next month";
          text = "totalSuspended";
          break;
        case "ewalletBalance":
          img = "E-Wallet-w.png";
          background = style.violet;
          break;
        case "purchaseWallet":
          img = "income-w.png";
          background = style.pink;
          break;
        case "commissionEarned":
          img = "income-w.png";
          background = style.blue;
          break;
        default:
          background = style.blue;
          img = "income-w.png";
      }
      // background = style.blue
      return {
        amount: items.amount,
        text: text,
        background: background,
        tiles: items.tiles,
        img: img,
        color: color,
        tool: tool,
      };
    });
    setData(ewalletTiles);
  }, [setData, props.tilesData]);
  console.log("currency------------<>", Currency);
  return (
    <div
      className={`${style.ewalletTiles}`}
      style={{ display: "flex", flexWrap: "wrap" }}
    >
      {data.map((tiles, index) => {
        console.log("tiles image goes here ", tiles);
        if (tiles.text == "totalSuspended") {
          return (
            <div
              className={`${
                currentTheme == "theme-dark"
                  ? `${style.dark_mode_Tiles} d-flex`
                  : `${style.Tiles} d-flex`
              }`}
              key={index}
              style={{
                margin: "2rem",
                padding: "2em 6em 2em 2em",
                backgroundColor: "#ffd9d9",
                borderRadius: ".5rem",
              }}
            >
              <div className={`${style.leftIcon} ${tiles.background}`}>
                <img
                  style={{ backgroundBlendMode: "multiply", padding: "10px" }}
                  src={
                    require(`../../../../assets/images/logos/${tiles.img}`)
                      .default
                  }
                  alt=""
                  blended
                />
              </div>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_tilesData}`
                    : `${style.tilesData}`
                }`}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  color: "#565656",
                }}
              >
                <h4 style={{ textAlign: "center" }}>
                  {" "}
                  {/* <strong style={{ color: tiles.color }}> {tiles.text}</strong>
                   */}
                  <strong style={{ color: "red" }}>
                    {" "}
                    {t(`ewallet.${tiles.text}`)}
                  </strong>
                </h4>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {tiles.tiles.map((tile) => {
                    // return <h1>{tile.text}</h1>;
                    return (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          color: "#565656",
                        }}
                      >
                        <h4 style={{ textAlign: "center" }}>
                          {" "}
                          <strong style={{ color: "black" }}>
                            {" "}
                            {t(`ewallet.${tile.text}`)}
                            {/* {tile.text} */}
                          </strong>
                        </h4>
                        <span
                          style={{ color: "black" }}
                          className={`${style.TilesAmount} ${style.bold} ${style.center}`}
                          title={(tile.amount * Currency.value).toFixed(
                            Currency.precision
                          )}
                        >
                          <strong>
                            <h3 style={{ textAlign: "center" }}>
                              {tile.text === "ilifestyle"
                                ? CurrencyDecimalFormat(
                                    tile.amount * Currency.value,
                                    Currency.precision
                                  )
                                : Currency.currentCurr +
                                  " " +
                                  CurrencyDecimalFormat(
                                    tile.amount * Currency.value,
                                    Currency.precision
                                  )}
                              {/* {`${Currency.currentCurr}` +
                                "   " +
                                CurrencyDecimalFormat(
                                  tile.amount * Currency.value,
                                  Currency.precision
                                )} */}
                            </h3>
                          </strong>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  margin: "-1.5em -5em 0px 100px",
                }}
              >
                <FaInfoCircle
                  size={"1.5rem"}
                  color="black"
                  data-toggle="tooltip"
                  title={tiles.tool}
                />
              </div>
            </div>
          );
        }
        return (
          <div
            className={`${
              currentTheme == "theme-dark"
                ? `${style.dark_mode_Tiles} d-flex`
                : `${style.Tiles} d-flex`
            }`}
            key={index}
            style={{
              margin: "2rem",
              padding: "2em 6em 2em 2em",
              backgroundColor: tiles.background,
              borderRadius: ".5rem",
            }}
          >
            <div className={`${style.leftIcon} ${tiles.background}`}>
              <img
                style={{ backgroundBlendMode: "multiply", padding: "10px" }}
                src={
                  require(`../../../../assets/images/logos/${tiles.img}`)
                    .default
                }
                alt=""
                blended
              />
            </div>
            <div
              className={`${
                currentTheme == "theme-dark"
                  ? `${style.dark_mode_tilesData}`
                  : `${style.tilesData}`
              }`}
              style={{
                display: "flex",
                flexDirection: "column",
                color: "#565656",
              }}
            >
              {/* <small>Your Total Maintenance PV for the Month of </small> */}
              <h4 style={{ textAlign: "center" }}>
                {" "}
                {/* <strong> {t("Common." + tiles.text)}</strong> */}
                {/* <strong style={{ color: tiles.color }}> {tiles.text}</strong> */}
                <strong style={{ color: tiles.color }}>
                  {" "}
                  {t(`ewallet.${tiles.text}`)}
                </strong>
              </h4>
              <span
                style={{ color: "black" }}
                className={`${style.TilesAmount} ${style.bold} ${style.center}`}
                title={(tiles.amount * Currency.value).toFixed(
                  Currency.precision
                )}
              >
                {/* {Currency.currentCurr}{" "} */}
                <strong>
                  <h3 style={{ textAlign: "center" }}>
                    {`${Currency.currentCurr}` +
                      "   " +
                      CurrencyDecimalFormat(
                        tiles.amount * Currency.value,
                        Currency.precision
                      )}
                  </h3>
                </strong>
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                margin: "-1.5em -5em 0px 100px",
              }}
            >
              <FaInfoCircle
                size={"1.5rem"}
                color="black"
                data-toggle="tooltip"
                title={tiles.tool}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Tiles;
